/**
 * Parse a pasted Loom share or embed URL into a video id for embedding.
 * Only accepts loom.com / www.loom.com to avoid arbitrary iframe targets.
 */
export function parseLoomVideoId(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  let url: URL;
  try {
    url = new URL(
      trimmed.startsWith('http://') || trimmed.startsWith('https://') ? trimmed : `https://${trimmed}`,
    );
  } catch {
    return null;
  }
  const host = url.hostname.toLowerCase();
  if (host !== 'loom.com' && host !== 'www.loom.com') return null;
  const m = url.pathname.match(/\/(?:share|embed)\/([a-zA-Z0-9_-]+)/);
  return m ? m[1] : null;
}

/** Canonical embed URL for an iframe (Loom-hosted only). */
export function loomEmbedSrcFromPaste(raw: string): string | null {
  const id = parseLoomVideoId(raw);
  if (!id) return null;
  return `https://www.loom.com/embed/${id}?hide_owner=true&hide_share=true`;
}
